import CryptoJS from 'crypto-js'

const AES_KEY = process.env.VUE_APP_ADMIN_AES_KEY || 'M5H7M6OIOAmH4nk7'
const AES_ENABLE = process.env.VUE_APP_ADMIN_AES_ENABLE === 'true'

/**
 * AES-128-CBC 加密
 * 格式: base64(iv):base64(encrypted)
 * @param {string} data - 需要加密的字符串
 * @returns {string}
 */
export function aesEncrypt(data) {
  const key = CryptoJS.enc.Utf8.parse(AES_KEY)
  const iv = CryptoJS.lib.WordArray.random(16)
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Base64.stringify(iv) + ':' + encrypted.toString()
}

/**
 * AES-128-CBC 解密
 * @param {string} encryptedStr - 格式 base64(iv):base64(encrypted)
 * @returns {string}
 */
export function aesDecrypt(encryptedStr) {
  const parts = encryptedStr.split(':')
  if (parts.length !== 2) {
    throw new Error('解密格式错误')
  }
  const [ivBase64, encryptedData] = parts
  const key = CryptoJS.enc.Utf8.parse(AES_KEY)
  const iv = CryptoJS.enc.Base64.parse(ivBase64)
  const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}

export { AES_ENABLE }
